import { apiClient } from '../api/axios';

export interface LookupDto {
    id: number;
    name: string;
    active: boolean;
}

export const lookupService = {
    getTitles: async (): Promise<LookupDto[]> => {
        const response = await apiClient.get('/Titles/GetTitles?Active=true', { skipAuth: true } as any);
        return response.data.data;
    },

    getStates: async (): Promise<LookupDto[]> => {
        const response = await apiClient.get('/States/GetStates?Active=true', { skipAuth: true } as any);
        return response.data.data;
    },

    getQualifications: async (): Promise<LookupDto[]> => {
        const response = await apiClient.get('/Qualifications/GetQualifications?Active=true', { skipAuth: true } as any);
        return response.data.data;
    },

    getRanks: async (): Promise<LookupDto[]> => {
        const response = await apiClient.get('/Ranks/GetRanks?Active=true', { skipAuth: true } as any);
        return response.data.data;
    },

    getInstitutionCategories: async (): Promise<LookupDto[]> => {
        // These will be hardcoded in the component as per user request
        return [
            { id: 1, name: 'University', active: true },
            { id: 2, name: 'Polytechnic', active: true },
            { id: 3, name: 'College', active: true },
        ];
    },

    getInstitutions: async (category: number, isPublic: boolean): Promise<LookupDto[]> => {
        const response = await apiClient.get(`/Institutions/GetInstitutions?institutionCategory=${category}&isPublicInstitution=${isPublic}&Active=true`, { skipAuth: true } as any);
        return response.data.data;
    },
};
